import React, { useState, useEffect } from "react";
import { Button } from "@mui/material";
import { URLS } from "../../helpers/URLS";
import EditIcon from "@mui/icons-material/Edit";
import useAxios from "../../helpers/Hooks/useAxios";
import moment from "moment";
import Tooltip from '@mui/material/Tooltip';
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel"
import ErrorIcon from '@mui/icons-material/Error';
import SkeletonLoader from "../../loaders/Skeleton";
import NoData from "../../loaders/NoData";
import PaginationGlobal from "../TablePagination.js/PaginationGlobal";
import ApplyModal from "../Attendance/ApplyModal";

const Leaves = () => {

  const { fetchData } = useAxios();
  const [loadSkeleton, setLoadSkeleton] = useState(true);
  const [myLeaves, setMyLeaves] = useState([]);
  const [app, setApp] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);

  useEffect(() => {
    getMyleaves();
  }, []);

  const getMyleaves = async () => {
    setLoadSkeleton(true);
    const response = await fetchData({
      url: URLS.getMyLeaveRequests,
      method: "get",
    });
    if (response.status === 200) {
      setMyLeaves(response.data);
      setLoadSkeleton(false);
    }
  };

  /* the request being edited, or null for a new one */
  const [editingLeave, setEditingLeave] = useState(null);

  const handleCloseApprove = () => {
    setApp(false);
    setEditingLeave(null);
  }

  const handleOpenApprove = () => {
    setEditingLeave(null);
    setApp(true);
  };

  const pull_data = (data) => {
    setPageNumber(data)
  }

  const countPerPage = 10;

  return (
    <div className="leaves-page">
      <div className="p-0">
        <div className="d-flex align-items-center">
          <h4 className="title">My Leaves</h4>
          <div className="ms-auto">
            <Button variant="contained" onClick={handleOpenApprove} className="apply-leave-btn mb-2">
              Apply Leave
            </Button>
          </div>
        </div>
        {
          loadSkeleton ? <SkeletonLoader /> : (
            myLeaves.length > 0 ?
              <div className="bg-wht">
                <div className="table-responsive tab-styles">
                <table className="table">
                  <thead>
                    <tr>
                      <th>From</th>
                      <th>To</th>
                      <th>Remarks</th>
                      <th>Reason</th>
                      <th>Status</th>
                      <th>Leave Type</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {myLeaves.length > 0
                      ? myLeaves && myLeaves.slice((pageNumber - 1) * countPerPage, pageNumber * countPerPage).map((leave,index) => (
                        <tr key={index}>
                          <td>{moment(leave.startDate).format("DD-MM-YYYY")}</td>
                          <td>{moment(leave.endDate).format("DD-MM-YYYY")}</td>
                          <td>{leave.remarks}</td>
                          <td>{leave.reason ? leave.reason : "No Comments.."}</td>
                          <td className="text-capitalize">
                            <div className="d-flex">
                              {leave.status === "pending" ? (
                                <ErrorIcon className="text-warning me-2" />
                              ) : leave.status === "approved" ? (
                                <CheckCircleIcon className="text-success me-2" />
                              ) : leave.status === "rejected" ? (
                                <CancelIcon className="text-danger me-2" />
                              ) : null}
                              {leave.status}
                            </div>
                          </td>
                          <td>{leave.leaveType.leaveType}</td>
                          <td>
                            <Tooltip title="Edit Leaves" placement="top" arrow>
                              <span>
                              <button
                                disabled={leave.status === "approved"}
                                className="btn btn-secondary p-0 me-1"
                                onClick={() => {
                                  setEditingLeave(leave);
                                  setApp(true);
                                }}
                              >
                                <EditIcon />
                              </button>
                              </span>
                            </Tooltip>
                          </td>
                        </tr>
                      ))
                      : ""}
                  </tbody>
                </table>
                </div>
                {myLeaves && myLeaves.length > 0 ? <PaginationGlobal count={Math.ceil(myLeaves.length / countPerPage)} pageNumber={pageNumber} func={pull_data} /> : ''}
              </div>
              : <NoData />
          )
        }
        <div>
          <ApplyModal
            show={app}
            leave={editingLeave}
            onClose={handleCloseApprove}
            onSaved={getMyleaves}
          />
        </div>
      </div>
    </div>
  );
};

export default Leaves;

